import axios from "axios";
import { API_CONFIG } from '../../config/api';

export const COMMAND_API = {
    getCommands: (token: string, missionId: string) => axios.get(
        `${API_CONFIG.HOSTNAME}${API_CONFIG.API_PREFIX}${API_CONFIG.API_VERSION}/command/${missionId}/?duration=1h`,
        { headers: { "Content-type": "application/json", Authorization: "Token " + token } }
    ),
    getCommandsWithDate: (token: string, missionId: string, from: string, to: string) => axios.get(
        `${API_CONFIG.HOSTNAME}${API_CONFIG.API_PREFIX}${API_CONFIG.API_VERSION}/command/${missionId}/?date_from=${from}&date_to=${to}`,
        { headers: { "Content-type": "application/json", Authorization: "Token " + token } }
    ),
    getCommandsHistory: (token: string, missionId: string, from: string, to: string) => axios.get(
        `${API_CONFIG.HOSTNAME}${API_CONFIG.API_PREFIX}${API_CONFIG.API_VERSION}/command/${missionId}/?date_from=${from}&date_to=${to}&history`,
        { headers: {"Content-type": "application/json", Authorization: "Token " + token } }
    ),
    sendRelayCommand: (token: string, missionId: string, plid: string, parameters: {relayId: string, state: number}) => axios.post(
        `${API_CONFIG.HOSTNAME}${API_CONFIG.API_PREFIX}${API_CONFIG.API_VERSION}/command/${missionId}/`,
        { destination_id: plid, payload: { type: "relay", id: parameters.relayId, state: parameters.state } },
        { headers: { "Content-type": "application/json", Authorization: "Token " + token } }
    ),
    sendBuzzerCommand: (token: string, missionId: string, plid: string, parameters: {frequency: number}) => axios.post(
        `${API_CONFIG.HOSTNAME}${API_CONFIG.API_PREFIX}${API_CONFIG.API_VERSION}/command/${missionId}/`,
        { destination_id: plid, payload: { type: "buzzer", frequency: parameters.frequency } },
        { headers: { "Content-type": "application/json", Authorization: "Token " + token } }
    )
};